import React, { useContext, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { MdLogout } from "react-icons/md";
import { AdminContext } from "../Contexts/AdminContext";

const AdminPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { logout } = useContext(AdminContext);
  const location = useLocation();

  const getLinkClasses = (path) => {
    return `flex items-center px-4 py-2 mt-2 text-gray-100 ${
      location.pathname === path ? "tabs--active" : ""
    }`;
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 transform ${
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 md:relative md:flex flex-col w-80 transition-transform duration-300 ease-in-out z-50`}
      >
        <div className="flex items-center justify-center h-16 bg-primary border-b-2 border-primary">
          <img src="/images/logo.png" className="h-1/2" alt="Logo" />
        </div>
        <div className="flex flex-col flex-1 overflow-y-auto">
          <nav className="flex-1 px-2 py-6 bg-primary font-poppins tabs">
            <Link
              to="/admin/dashboard"
              className={getLinkClasses("/admin/dashboard")}
              onClick={() => setIsMobileMenuOpen(false)} // Close menu when clicked
            >
              <MdDashboard className="h-6 w-6 mr-2" />
              Dashboard
            </Link>
            <Link
              to="/admin/add"
              className={getLinkClasses("/admin/add")}
              onClick={() => setIsMobileMenuOpen(false)} // Close menu when clicked
            >
              <FaPlus className="h-6 w-6 mr-2" />
              Add
            </Link>
            <Link
              to="/admin/view"
              className={getLinkClasses("/admin/view")}
              onClick={() => setIsMobileMenuOpen(false)} // Close menu when clicked
            >
              <FaEye className="h-6 w-6 mr-2" />
              View
            </Link>
            <Link
              to="/"
              className={getLinkClasses("/")}
              onClick={() => {
                logout();
                setIsMobileMenuOpen(false); // Close menu when clicked
              }}
            >
              <MdLogout className="h-6 w-6 mr-2" />
              Log Out
            </Link>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-y-auto">
        <div className="flex items-center justify-between h-16 bg-gray-900 border-b border-primary">
          <div className="flex items-center px-4 py-5">
            <button
              className="text-gray-500 focus:outline-none focus:text-gray-700 md:hidden"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
          <div className="flex items-center pr-4">
            <button className="flex items-center text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 19l-7-7 7-7m5 14l7-7-7-7"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
